"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectableBodyRow = SelectableBodyRow;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _Checkbox = require("../../../elements/checkbox/Checkbox");
var _BodyRow = require("../body-row/BodyRow");
var _classnames = _interopRequireDefault(require("classnames"));
var _selectableBodyRowModule = _interopRequireDefault(require("./selectable-body-row.module.scss"));
var _Tooltip = require("../../tooltip/Tooltip");
var _excluded = ["selected", "onSelect", "children", "row", "className", "disabled", "disabledReason"];
function SelectableBodyRow(_ref) {
  var selected = _ref.selected,
    onSelect = _ref.onSelect,
    children = _ref.children,
    row = _ref.row,
    className = _ref.className,
    disabled = _ref.disabled,
    disabledReason = _ref.disabledReason,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_BodyRow.BodyRow, Object.assign({}, rest, {
    row: row,
    className: (0, _classnames.default)(className, (0, _defineProperty2.default)({}, _selectableBodyRowModule.default['selectable-body-row--selected'], selected))
  }), row && /*#__PURE__*/_react.default.createElement("td", {
    className: _selectableBodyRowModule.default['selectable-body-row__checkbox'],
    "data-testid": "selectable-body-row-checkbox"
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    title: disabled && disabledReason,
    position: "bottom-right",
    variant: "light",
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
    disabled: disabled,
    id: row.id,
    name: row.id,
    checked: selected,
    onChange: function onChange(e) {
      e.stopPropagation();
      onSelect(row, e.currentTarget.checked);
    }
  }))), children);
}